import React, { useState, useEffect } from "react";
import Link from "components/Link";
import Image from "components/Image";

const CardLarge1 = ({ className = "", post, isActive = false }) => {
  const [loaded, setLoaded] = useState(false);

  const postUrl = `/${post?.title.toLowerCase()}/${
    post?.name === "Świat" ? "swiat" : post?.name.toLowerCase()
  }/${post?.category_id}/${post?.subcategory_id}/artykuł/${post?.id}`;

  // Preload the first image for faster LCP
  useEffect(() => {
    if (isActive && post?.image) {
      const preloadImage = document.createElement("link");
      preloadImage.rel = "preload";
      preloadImage.as = "image";
      preloadImage.href = post.image.replace(".jpg", ".webp");
      document.head.appendChild(preloadImage);

      return () => {
        document.head.removeChild(preloadImage);
      };
    }
  }, [isActive, post?.image]);

  return (
    <div
      className={`nc-CardLarge1 card-source flex flex-col md:flex-row transition-opacity duration-500 ${className}`}
      style={{
        minHeight: "254px",
        backgroundColor: loaded ? "transparent" : isActive ? "transparent" : "#eee",
        position: "relative",
      }}
    >
      <Link href={postUrl}>
        <Image
          src={post?.image.replace(".jpg", ".webp")}
          alt={post?.article_title}
          className="large-card"
          loading={isActive ? "eager" : "lazy"} // eager for active (first) image
          fetchPriority={isActive ? "high" : "auto"} // High priority for first image
          decoding="async" // Helps with non-blocking decoding
          onLoad={() => setLoaded(true)}
          style={{
            aspectRatio: "16/9",
            objectFit: "cover",
            width: "100%",
            minHeight: "254px",
            opacity: loaded || isActive ? 1 : 0,
            transition: "opacity 0.4s ease",
          }}
        />
      </Link>

      {/* Show description only if image is loaded */}
      {loaded && (
        <div
          className="slider-breadcumb"
          style={{
            display: "flex",
            flexFlow: "column",
            maxWidth: "912px",
            gap: "10px",
          }}
        >
          <h3 className="slider-font">
            <Link
              style={{ color: "white" }}
              href={postUrl}
              className="slider-font"
              title={post?.article_title}
            >
              {post?.article_title}
            </Link>
          </h3>
        </div>
      )}
    </div>
  );
};

export default CardLarge1;